import React from 'react'
import {Link} from 'react-router-dom'
import { KTSVG } from '../../../../../../template/_metronic/helpers'

export const StepComplete = () => {
  return (
    <div className='w-100'>
      <div className='d-flex justify-content-center mb-20' data-wizard-type='step-content'>
        <div className='d-flex flex-column'>
          <div className='mx-auto'>
            <KTSVG path='/media/soyfri-media/check-circle-svgrepo-com.svg' className='svg-icon-5x' />
          </div>
          <div className='text-center mt-10'>
            <span className='text-primary-dark fs-2x fw-semibold'>¡Pago programado!</span>
            <div className='text-lg-nowrap text-gray fs-2'>
              Ahora puedes verlo en “Pagos programados”
            </div>
            <div className='text-lg-nowrap text-gray fs-2'>
              Puedes modificar o cambiar la fecha de un pago que todavía no se ha realizado.
            </div>
          </div>
        </div>
      </div>
      <div className='d-flex flex-row-reverse'>
        <Link to='/scheduled' className='btn btn-primary d-flex align-items-center justify-content-center'>
          Ir a pagos programados
        </Link>
      </div>
    </div>
  )
}
